import {Component, OnInit} from '@angular/core';
import {Backgrounds, Character, CharacterService} from '../../services/character.service';
import htmlToImage from 'html-to-image';
import download from 'downloadjs';

interface BackgroundFilter {
  name: Backgrounds;
  show: boolean;
}

@Component({
  templateUrl: './home.page.html',
})
export class HomePage implements OnInit {

  public characters: Array<Character> = [];
  public showBackgrounds: Array<BackgroundFilter> = [
    {name: 'Arth', show: true},
    {name: 'Fiendheim', show: true},
    {name: 'Nova', show: true},
  ];

  constructor(public characterService: CharacterService) {
  }

  public cardClick(character: Character, cardIndex: number) {
    const el = document.getElementById('card' + cardIndex);
    const cardImageName = this.characterService.safeName(character.name) + '.png';
    htmlToImage.toPng(el)
               .then((dataUrl) => {
                 const img = new Image();
                 download(dataUrl, cardImageName);
               })
               .catch((error) => {
                 console.error('oops, something went wrong!', error);
               });
  }

  public imageSrc(character: Character): string {
    return '/assets/images/characters/' + character.faction + '/' + this.characterService.safeName(character.name) + '.png';
  }

  public cardClass(character: Character): string {
    return character.background.toLowerCase();
  }

  public onFileChange(fileEvent: any) {
    this.characterService.loadSheet(fileEvent.target.files[0]);
  }

  public matchesFilter(character: Character) {
    for (const showBackground of this.showBackgrounds) {
      if (character.background === showBackground.name) {
        return showBackground.show;
      }
    }
    return true;
  }

  ngOnInit(): void {
    this.characters = this.characterService.characters;
  }
}
